export default "__VITE_ASSET__CHi01KI1__"